import type { QuoteTag } from 'paintscout'
import React from 'react'
import TagIcon from '@material-ui/icons/LocalOffer'
import { Grid, makeStyles, Tooltip, QuoteTagChip } from '@paintscout/ui'
import type { TooltipProps, MuiTheme as Theme } from '@paintscout/ui'

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    width: 'fit-content'
  },
  tooltip: {
    backgroundColor: 'white',
    boxShadow: theme.shadows[1]
  },
  tooltipPopper: {
    zIndex: theme.zIndex.appBar - 1
  },
  icon: {
    width: 16,
    height: 16
  }
}))

export interface QuoteTagIconsProps {
  tags: QuoteTag[]
}

export function QuoteTagIcons({ tags }: QuoteTagIconsProps) {
  const classes = useStyles()
  return (
    <Grid container alignItems="center" className={classes.container}>
      {tags.map((tag) => {
        return <TagIcon key={tag.name} style={{ color: tag.color }} className={classes.icon} />
      })}
    </Grid>
  )
}

export function QuoteListTagPopup(tags: QuoteTag[]) {
  const classes = useStyles()
  return (
    <Grid container spacing={1} className={classes.container}>
      {tags.map((tag) => {
        return (
          <Grid item key={tag.name}>
            <QuoteTagChip tag={tag} handleClick={(tag) => console.log(tag)} />
          </Grid>
        )
      })}
    </Grid>
  )
}

export function QuoteTagTooltip(args: { children: React.ReactElement; tags: QuoteTag[]; tooltipProps?: TooltipProps }) {
  const { children, tags, tooltipProps } = args
  const classes = useStyles()

  return (
    <Tooltip
      interactive
      content={QuoteListTagPopup(tags)}
      icon={<></>}
      open={true}
      PopperProps={{ disablePortal: true }}
      classes={{ htmlTooltip: classes.tooltip, popper: classes.tooltipPopper }}
      {...tooltipProps}
    >
      {children}
    </Tooltip>
  )
}
